import React, { useEffect, useState } from 'react';
import {
  Badge,
  Button,
  Col,
  Container,
  Row,
  FormControl,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Modal,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import InfoCard from '~/Components/InfoCard/InfoCard';
import MapaQuadriculado from '~/Components/MapaQuadriculado/MapaQuadriculado';
import ContadorLotes from '~/Components/ContadorLotes/ContadorLotes';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import * as api from '~/Services/Service';
import { formatarMonetario } from '~/Utils/Helpers';
import { StatusImovel, EMPREENDIMENTO_LANCAMENTO, REPOSITORIO_URL } from '~/constant';
import {
  FaTrashAlt,
  FaTicketAlt,
  FaList,
  FaPiggyBank,
  FaShoppingCart,
  FaExchangeAlt,
} from 'react-icons/fa';
import Select from 'react-select';
import SimuladorFinanceiro from '~/Pages/SimuladorFinanceiro';
import { LotesDisponiveisModal } from '~/Pages/LotesDisponiveis/Index';
import { ContaBancariaModal } from '~/Pages/EmpreendimentosContaBancaria';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import AuthStorage from '~/Utils/AuthStorage';

const descricaoComprovante = {
  0: 'Venda sem Dep/Cartão/Cheque',
  1: 'Aguardando Comprovante',
  2: 'Comprovante Inserido',
  3: 'Aprovado Sec. Vendas',
  4: 'Aprovado Dpto. Financeiro',
  5: 'Aprovado Sec. Vendas (Somente Cheque)',
  8: 'Recusado Dpto. Financeiro',
  9: 'Recusado Sec. Vendas',
};

const MotivoBloqueioReserva = {
  Nenhum: 0,
  SemCpf: 1,
  Negativado: 2,
  PendenciaJudicialSemSolicitacao: 3,
  PendenciaJudicialEmAnalise: 4,
  PendenciaJudicialReprovada: 5,
};

const obterConfiguracaoPendencia = variante => {
  const configuracoes = {
    'cpf-negativado': {
      titulo: 'Pendência no CPF',
      etiqueta: 'CPF negativado',
      tom: 'erro',
      descricao:
        'O CPF informado possui pendência cadastral/financeira e não pode ser usado para reserva enquanto a situação estiver ativa.',
      acao:
        'Oriente o corretor a regularizar a situação do prospecto antes de tentar reservar novamente.',
      botaoCancelar: 'Fechar',
    },
    'sem-solicitacao': {
      titulo: 'Pendência judicial no CPF',
      etiqueta: null,
      tom: 'alerta',
      descricao:
        'O prospecto possui pendência jurídica vinculada ao CPF no Lawyer. A reserva deste ativo está bloqueada até autorização do Jurídico/Comercial.',
      acao:
        'Use Solicitar Autorização para enviar a análise. A reserva não será realizada neste momento.',
      botaoCancelar: 'Cancelar',
    },
    'em-analise': {
      titulo: 'Solicitação em análise',
      etiqueta: 'Análise pendente',
      tom: 'alerta',
      descricao:
        'Já existe uma solicitação de autorização para este prospecto e ativo.',
      acao:
        'Aguarde a decisão do Jurídico/Comercial antes de tentar realizar a reserva novamente.',
      botaoCancelar: 'Fechar',
    },
    reprovada: {
      titulo: 'Solicitação recusada',
      etiqueta: 'Autorização recusada',
      tom: 'erro',
      descricao:
        'A solicitação de autorização para este prospecto e ativo foi reprovada.',
      acao:
        'A reserva permanece bloqueada para este prospecto neste ativo.',
      botaoCancelar: 'Cancelar',
    },
  };

  return (
    configuracoes[variante] || {
      titulo: 'Reserva bloqueada',
      etiqueta: 'Bloqueio',
      tom: 'alerta',
      descricao: 'A reserva não pode ser realizada neste momento.',
      acao: 'Verifique a pendência antes de tentar novamente.',
      botaoCancelar: 'Fechar',
    }
  );
};

const separarMensagemPendencia = mensagem => {
  const linhas = (mensagem || '')
    .split('\n')
    .map(linha => linha.trim())
    .filter(linha => linha);
  const resultado = {
    resumo: [],
    detalhes: [],
  };
  let lendoProcessos = false;

  linhas.forEach(linha => {
    if (linha.toLowerCase() === 'processos encontrados:') {
      lendoProcessos = true;
      return;
    }

    if (lendoProcessos) {
      const ehProcesso =
        linha.indexOf('CNJ:') >= 0 ||
        linha.indexOf('Situação:') >= 0 ||
        linha.indexOf('Pasta:') >= 0;

      if (ehProcesso) {
        return;
      }

      lendoProcessos = false;
    }

    if (resultado.resumo.length === 0) {
      resultado.resumo.push(linha);
      return;
    }

    resultado.detalhes.push(linha);
  });

  return resultado;
};

const borderColor = '#007bff';
const checkboxStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginRight: 6,
  marginBottom: 0,
};

const checkboxInputStyle = {
  width: 14,
  height: 14,
  marginRight: 3,
  cursor: 'pointer',
};
const checkboxLabelStyle = {
  margin: 0,
  fontWeight: 400,
  cursor: 'pointer',
  fontSize: 13,
  whiteSpace: 'nowrap',
};

var colunasReservados = [
  {
    title: 'Cód. Ativo',
    key: 'codigo_ativo',
    ordenacao: true,
    align: 'center',
    width: '80px',
  },
  { title: 'Quadra', key: 'mapa1', ordenacao: false, align: 'center' },
  { title: 'Lote', key: 'mapa2', ordenacao: false, align: 'center' },
  {
    title: 'Prospecto',
    key: 'codigo_prospecto',
    ordenacao: true,
    align: 'center',
  },
  {
    title: 'Vencimento',
    key: 'data_vencimento',
    ordenacao: true,
    align: 'center',
    render: function(value) {
      if (!value) return '-';
      var data = new Date(value);
      return (
        data.toLocaleDateString('pt-BR') +
        ' ' +
        data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      );
    },
  },
];

const MapaEmprendimento = function() {
  const empreendimentos = useSelector(state => state.empreendimentos);
  const [empreendimentoSelected, setEmpreendimentoSelected] = useState(null);
  const [reservados, setReservados] = useState([]);
  const [loadingMapa, setLoadingMapa] = useState(false);
  const [loadingReservados, setLoadingReservados] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [empreendimentoData, setEmpreendimentoData] = useState();
  const [detalhesAtivo, setDetalhesAtivo] = useState({});
  const [mostrarSimulador, setMostrarSimulador] = useState(false);
  const [codigoAtivoSimulador, setCodigoAtivoSimulador] = useState(null);
  const [filtroTipologias, setFiltroTipologias] = useState([]);
  const [filtroQuadras, setFiltroQuadras] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState([]);
  const [mostrarLotesDisponiveis, setMostrarLotesDisponiveis] = useState(false);
  const [mostrarContaBancaria, setMostrarContaBancaria] = useState(false);
  const [codigoProspecto, setCodigoProspecto] = useState('');
  const [mostrarAvisoInadimplente, setMostrarAvisoInadimplente] = useState(
    false
  );
  const [avisoInadimplente, setAvisoInadimplente] = useState('');
  const [mostrarModalPendencia, setMostrarModalPendencia] = useState(false);
  const [variantePendencia, setVariantePendencia] = useState(null);
  const [mensagemPendencia, setMensagemPendencia] = useState('');
  const [solicitandoPendencia, setSolicitandoPendencia] = useState(false);
  const [reservaSelecionada, setReservaSelecionada] = useState(null);
  const [mostrarTransferencia, setMostrarTransferencia] = useState(false);
  const [opcoesTransferencia, setOpcoesTransferencia] = useState([]);
  const [transferenciaTarget, setTransferenciaTarget] = useState(null);
  const [prospectoTransferencia, setProspectoTransferencia] = useState('');
  const [loadingTransferencia, setLoadingTransferencia] = useState(false);
  const [mostrarModalCancelamento, setMostrarModalCancelamento] = useState(
    false
  );
  const [ativoCancelamento, setAtivoCancelamento] = useState(null);
  const [motivosCancelamento, setMotivosCancelamento] = useState([]);
  const [motivosSelecionados, setMotivosSelecionados] = useState([]);
  const [observacoesCancelamento, setObservacoesCancelamento] = useState('');
  const [cancelando, setCancelando] = useState(false);
  const [isModeLancamento, setIsModeLancamento] = useState(false);
  const [isAutoSelected, setIsAutoSelected] = useState(false);
  const [quantidadeFila, setQuantidadeFila] = useState(null);
  const [loadingFila, setLoadingFila] = useState(false);
  const [implantacaoArquivo, setImplantacaoArquivo] = useState(null);
  const [justificativaAdmin, setJustificativaAdmin] = useState('');
  const [tabelasDisponiveis, setTabelasDisponiveis] = useState([]);
  const [indiceTabela, setIndiceTabela] = useState(-1);
  const [dadosTabela, setDadosTabela] = useState(null);
  const [loadingTabela, setLoadingTabela] = useState(false);
  const temCaracteristica453 = AuthStorage.temCaracteristica(453);
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prospecto = queryParams.get('prospecto');
  const familia = queryParams.get('familia');

  const optionsEmpreendimento = [
    ...empreendimentos.sort.map(item => ({
      value: item.codigo,
      label: item.codigo + ' - ' + item.descricao,
    })),
  ];

  useEffect(() => {
    if (prospecto) {
      setCodigoProspecto(prospecto);
    }
    // Prioridade: query string familia > lançamento ativo (LocalStorage > variável de módulo)
    const familiaAlvo = familia
      || ((user => (user && user.empreendimento_lancamento) || EMPREENDIMENTO_LANCAMENTO)(AuthStorage.getUser()));
    if (
      familiaAlvo &&
      optionsEmpreendimento.length > 0 &&
      !empreendimentoSelected
    ) {
      const option = optionsEmpreendimento.find(
        item => String(item.value) === String(familiaAlvo)
      );
      if (option) {
        handleSelectorChange(option);
      }
    }
  }, [prospecto, familia, empreendimentos.sort]);

  const fetchImoveis = async empreendimento => {
    try {
      setLoadingMapa(true);
      setError(null);
      const response = await api.buscarImoveisEmpreendimento(empreendimento);
      setEmpreendimentoData(response);
    } catch (err) {
      setError(err);
      toast.error(err.message || 'Erro ao buscar imóveis');
    } finally {
      setLoadingMapa(false);
    }
  };
  const abrirModalCancelamento = async rowData => {
    setAtivoCancelamento(rowData);
    setMotivosSelecionados([]);
    setObservacoesCancelamento('');
    try {
      var response = await api.listarMotivosCancelamento();
      setMotivosCancelamento(response);
    } catch (err) {
      toast.error(err.message || 'Erro ao carregar motivos de cancelamento');
      return;
    }
    setMostrarModalCancelamento(true);
  };

  const fecharModalCancelamento = () => {
    setMostrarModalCancelamento(false);
    setAtivoCancelamento(null);
    setMotivosCancelamento([]);
    setMotivosSelecionados([]);
    setObservacoesCancelamento('');
  };

  var optionsMotivos = motivosCancelamento.map(m => ({
    value: m.codigo,
    label: m.descricao,
  }));

  var motivosSelecionadosComSubMotivos = motivosSelecionados
    .map(sel => motivosCancelamento.find(m => m.codigo === sel.value))
    .filter(m => m && m.sub_motivos && m.sub_motivos.length > 0);

  const atualizarSubMotivo = (codigoMotivo, codigoSubMotivo, dissertativa) => {
    setMotivosSelecionados(prev => {
      var atualizado = prev.map(item => {
        if (item.value === codigoMotivo) {
          return { ...item, codigo_submotivo: codigoSubMotivo, dissertativa };
        }
        return item;
      });
      return atualizado;
    });
  };

  var temMotivoSelecionado = motivosSelecionados.length > 0;

  const confirmarCancelamento = async () => {
    if (!temMotivoSelecionado) {
      toast.warning('Selecione pelo menos um motivo para excluir a reserva.');
      return;
    }

    var motivos = motivosSelecionados.map(sel => ({
      codigo_motivo: sel.value,
      codigo_submotivo: sel.codigo_submotivo || null,
      dissertativa: sel.dissertativa || '',
    }));

    var payload = {
      motivos,
      observacoes: observacoesCancelamento,
    };

    try {
      setCancelando(true);
      var codigoAtivo = ativoCancelamento.codigo_ativo;
      await api.excluirReservaComJustificativa(codigoAtivo, payload);
      setReservados(prev =>
        prev.filter(item => item.codigo_ativo !== codigoAtivo)
      );
      if (
        reservaSelecionada &&
        reservaSelecionada.codigo_ativo === codigoAtivo
      ) {
        setReservaSelecionada(null);
      }
      if (detalhesAtivo.codigo === codigoAtivo) {
        setDetalhesAtivo({});
        setIsAutoSelected(false);
      }
      fetchImoveis(empreendimentoSelected.value);
      toast.success('Reserva excluída com sucesso');
      fecharModalCancelamento();
    } catch (err) {
      toast.error(err.message || 'Erro ao excluir reserva');
    } finally {
      setCancelando(false);
    }
  };

  const fetchImplantacao = async codigoEmpreendimento => {
    try {
      var data = await api.SismacListar('implantacao', codigoEmpreendimento);
      var arquivos = data.arquivos || [];
      if (arquivos.length > 0) {
        setImplantacaoArquivo(arquivos[0].nome_completo);
      } else {
        setImplantacaoArquivo(null);
      }
    } catch (err) {
      setImplantacaoArquivo(null);
    }
  };

  const handleAbrirImplantacao = () => {
    const url = `${REPOSITORIO_URL}/Sismac/galerias/midia/implantacao/${
      empreendimentoSelected.value
    }/${encodeURIComponent(implantacaoArquivo)}`;
    window.open(url, '_blank');
  };

  const fetchReservados = async () => {
    if (!empreendimentoSelected) return;
    try {
      setLoadingReservados(true);
      const response = await api.listarLotesReservados(
        empreendimentoSelected.value
      );
      setReservados(response);
    } catch (err) {
      setError(err);
      toast.error(err.message || 'Erro ao listar reservados');
    } finally {
      setLoadingReservados(false);
    }
  };

  useEffect(() => {
    if (empreendimentoSelected !== null) {
      fetchReservados();
      fetchImplantacao(empreendimentoSelected.value);
    } else {
      setImplantacaoArquivo(null);
    }
  }, [empreendimentoSelected]);

  useEffect(() => {
    if (
      reservaSelecionada &&
      !reservados.some(r => r.codigo_ativo === reservaSelecionada.codigo_ativo)
    ) {
      setReservaSelecionada(null);
    }
  }, [reservados]);

  useEffect(() => {
    let cancelled = false;

    if (detalhesAtivo.codigo && !isAutoSelected) return;

    const candidatos = reservados.filter(r => r.codigo_prospecto);
    if (candidatos.length === 0) {
      if (isAutoSelected) {
        setDetalhesAtivo({});
        setIsAutoSelected(false);
      }
      return;
    }

    const usuarioLogado = AuthStorage.getUser().usuario;

    const tentarAutoSelecionar = async () => {
      for (const reserva of candidatos) {
        if (cancelled) return;
        try {
          const response = await api.buscarImovel(reserva.codigo_ativo);
          if (cancelled) return;
          if (
            response &&
            response.ticket &&
            response.ticket.codigo_usuario == usuarioLogado
          ) {
            setDetalhesAtivo(response);
            setIsAutoSelected(true);
            return;
          }
        } catch (err) {
          continue;
        }
      }
      if (!cancelled && isAutoSelected) {
        setDetalhesAtivo({});
        setIsAutoSelected(false);
      }
    };

    tentarAutoSelecionar();
    return () => {
      cancelled = true;
    };
  }, [reservados]);

  const handleSelectorChange = selected => {
    try {
      setEmpreendimentoSelected(selected);
      setFiltroQuadras([]);
      setReservaSelecionada(null);
      setQuantidadeFila(null);
      if (selected !== null) {
        setEmpreendimentoData(null);
        fetchImoveis(selected.value);
        setDetalhesAtivo({});
        setIsAutoSelected(false);
        setTabelasDisponiveis([]);
        setIndiceTabela(-1);
        setDadosTabela(null);
      } else {
        setEmpreendimentoData(null);
        setDetalhesAtivo({});
        setIsAutoSelected(false);
        setReservados([]);
        setError(null);
        setTabelasDisponiveis([]);
        setIndiceTabela(-1);
        setDadosTabela(null);
      }
      if (selected) {
        const params = new URLSearchParams();
        params.set('familia', selected.value);
        const prospectoAindaAplica =
          prospecto && String(selected.value) === String(familia);
        if (prospectoAindaAplica) {
          params.set('prospecto', prospecto);
        } else if (prospecto) {
          setCodigoProspecto('');
        }
        history.replace(`/mapa-empreendimento?${params.toString()}`);
      } else {
        if (prospecto) {
          setCodigoProspecto('');
        }
        history.replace('/mapa-empreendimento');
      }
    } catch (err) {
      setError(err);
      toast.error(err.message || 'Erro inesperado');
    }
  };

  const handleReservar = async () => {
    setLoading(true);
    var toastId = toast.info('Processando reserva...', { autoClose: false });
    try {
      var codigoAtivo = detalhesAtivo.codigo;

      const permissao = await api.permitirReserva({
        prospecto_cpf_codigo: codigoProspecto || null,
        codigo_familia: empreendimentoSelected.value,
        codigo_ativo: codigoAtivo,
      });

      if (!permissao.permitido) {
        toast.dismiss(toastId);
        const variantePorMotivo = {
          [MotivoBloqueioReserva.Negativado]: 'cpf-negativado',
          [MotivoBloqueioReserva.PendenciaJudicialSemSolicitacao]: 'sem-solicitacao',
          [MotivoBloqueioReserva.PendenciaJudicialEmAnalise]: 'em-analise',
          [MotivoBloqueioReserva.PendenciaJudicialReprovada]: 'reprovada',
        };
        const variante = variantePorMotivo[permissao.motivo_bloqueio];
        if (variante) {
          setVariantePendencia(variante);
          setMensagemPendencia(permissao.mensagem || '');
          setMostrarModalPendencia(true);
        } else {
          toast.error(permissao.mensagem || 'Não é possível reservar este imóvel.');
        }
        return;
      }

      const response = await api.reservarLote({
        codigo_ativo: codigoAtivo,
        prospecto_cpf_codigo: codigoProspecto || null,
        codigo_familia: empreendimentoSelected.value,
        justificativa: justificativaAdmin || null,
      });
      toast.dismiss(toastId);
      setEmpreendimentoData(function(prev) {
        if (!prev) return prev;
        return prev.map(function(lote) {
          if (lote.codigo === codigoAtivo) {
            return Object.assign({}, lote, { status: StatusImovel.Reservado });
          }
          return lote;
        });
      });

      toast.success('Lote reservado com sucesso');

      const aviso = permissao.mensagem || response.aviso;
      if (aviso) {
        setAvisoInadimplente(aviso);
        setMostrarAvisoInadimplente(true);
      }

      try {
        await Promise.all([
          fetchImoveis(empreendimentoSelected.value),
          fetchReservados(),
        ]);
      } catch (refreshErr) {
        try {
          await Promise.all([
            fetchImoveis(empreendimentoSelected.value),
            fetchReservados(),
          ]);
        } catch (retryErr) {
        }
      }
    } catch (err) {
      setError(err);
      toast.error(err.message || 'Erro ao reservar lote');
    } finally {
      toast.dismiss(toastId);
      setLoading(false);
    }
  };

  const handleSolicitarPendencia = async () => {
    setSolicitandoPendencia(true);
    try {
      await api.solicitarReservaPendente({
        prospecto_cpf_codigo: codigoProspecto || null,
        codigo_familia: empreendimentoSelected ? empreendimentoSelected.value : null,
        codigo_ativo: detalhesAtivo.codigo,
      });
      toast.success('Solicitação enviada. Você será notificado.');
      setMostrarModalPendencia(false);
    } catch (err) {
      toast.error(err.message || 'Erro ao enviar solicitação.');
    } finally {
      setSolicitandoPendencia(false);
    }
  };

  const handleTipologiaChange = tipologia => {
    setFiltroTipologias(prev =>
      prev.includes(tipologia)
        ? prev.filter(t => t !== tipologia)
        : [...prev, tipologia]
    );
  };

  const optionsQuadras = empreendimentoData
    ? empreendimentoData
        .map(lote => lote.quadra)
        .filter((q, i, arr) => q != null && arr.indexOf(q) === i)
        .sort((a, b) =>
          String(a).localeCompare(String(b), undefined, { numeric: true })
        )
        .map(q => ({ value: q, label: 'Quadra ' + q }))
    : [];

  const lotesFiltrados = empreendimentoData
    ? empreendimentoData.filter(lote => {
        const passaTipologia =
          filtroTipologias.length === 0 ||
          filtroTipologias.includes(lote.tipologia);
        const passaQuadra =
          filtroQuadras.length === 0 ||
          filtroQuadras.some(q => q.value === lote.quadra);
        const passaStatus =
          filtroStatus.length === 0 || filtroStatus.includes(lote.status);
        return passaTipologia && passaQuadra && passaStatus;
      })
    : null;

  const fetchImovelData = async codigoAtivo => {
    setLoading(true);
    setError(null);
    setQuantidadeFila(null);
    setLoadingFila(true);
    setTabelasDisponiveis([]);
    setIndiceTabela(-1);
    setDadosTabela(null);
    setLoadingTabela(true);
    try {
      const [response, fila] = await Promise.all([
        api.buscarImovel(codigoAtivo),
        api.buscarFilaLote({
          cpf: null,
          codigo_ativo: codigoAtivo,
          codigo_familia: 0,
          codigo_corretor: 0,
        }),
      ]);
      if (response) {
        setDetalhesAtivo(response);
        setIsAutoSelected(false);
      }
      setQuantidadeFila(Array.isArray(fila) ? fila.length : 0);

      try {
        const simulacao = await api.buscarSimulacaoFinanciamento(codigoAtivo);
        if (simulacao && simulacao.tabelas_disponiveis) {
          setTabelasDisponiveis(simulacao.tabelas_disponiveis);
          if (simulacao.codigo_tabela) {
            const idx = simulacao.tabelas_disponiveis.findIndex(
              t => t.codigo === simulacao.codigo_tabela
            );
            if (idx >= 0) setIndiceTabela(idx);
          }
        }
      } catch (_) {}
    } catch (err) {
      setError(err);
      toast.error(err.message || 'Erro ao buscar imóvel');
    } finally {
      setLoading(false);
      setLoadingFila(false);
      setLoadingTabela(false);
    }
  };

  const handleSelecionarTabela = async codigoTabela => {
    if (!detalhesAtivo.codigo) return;
    const novoIndice = tabelasDisponiveis.findIndex(
      t => t.codigo === codigoTabela
    );
    if (novoIndice < 0 || novoIndice === indiceTabela) return;
    setIndiceTabela(novoIndice);
    setLoadingTabela(true);
    try {
      const response = await api.buscarSimulacaoFinanciamento(
        detalhesAtivo.codigo,
        codigoTabela
      );
      setDadosTabela(response);
    } catch (err) {
      toast.error('Erro ao carregar tabela');
    } finally {
      setLoadingTabela(false);
    }
  };

  const getValoresTabela = () => {
    if (!dadosTabela) {
      return {
        valorSinal: detalhesAtivo.valor_sinal,
        valorVista: detalhesAtivo.valor_vista,
        parcelas: detalhesAtivo.parcelas,
        valorParcela: detalhesAtivo.valor_parcela,
        descricaoTabela: null,
        memorial_descritivo: detalhesAtivo.memorial_descritivo,
      };
    }
    const planos = (dadosTabela.planos || []).filter(p => p.plano > 0);
    let parcelas = null;
    let valorParcela = 0;
    if (planos.length > 0) {
      const plano = planos[0];
      const saldo = dadosTabela.saldo_financiar || 0;
      parcelas = String(plano.plano);
      valorParcela = plano.coeficiente === -1
        ? (plano.plano > 0 ? saldo / plano.plano : 0)
        : saldo * plano.coeficiente;
    }
    const tabela = tabelasDisponiveis[indiceTabela];
    return {
      valorSinal: dadosTabela.valor_entrada,
      valorVista: dadosTabela.valor_a_vista,
      parcelas,
      valorParcela,
      descricaoTabela: tabela ? tabela.descricao : null,
      memorial_descritivo: detalhesAtivo.memorial_descritivo,
    };
  };

  const prospectoUnicoReservados = (() => {
    const comProspecto = reservados.filter(r => r.codigo_prospecto);
    if (comProspecto.length === 0) return null;
    const primeiro = comProspecto[0].codigo_prospecto;
    const todosIguais = comProspecto.every(
      r => r.codigo_prospecto === primeiro
    );
    return todosIguais ? primeiro : null;
  })();

  const podeTransferir =
    detalhesAtivo.status === StatusImovel.Reservado &&
    AuthStorage.temCaracteristica(453) &&
    detalhesAtivo.ticket &&
    AuthStorage.getUser().usuario == detalhesAtivo.ticket.codigo_usuario;

  const abrirTransferencia = async () => {
    setMostrarTransferencia(true);
    setTransferenciaTarget(null);
    setProspectoTransferencia(
      detalhesAtivo.ticket && detalhesAtivo.ticket.codigo_prospecto
        ? detalhesAtivo.ticket.codigo_prospecto.toString()
        : ''
    );
    try {
      const mesas = await api.pegarInformacoesMapa(
        empreendimentoSelected.value
      );
      if (mesas && mesas.length > 0) {
        setIsModeLancamento(true);
        setOpcoesTransferencia(
          mesas.map(m => ({
            label: m.descricao,
            value: m.codigo_usuario,
            prospecto: m.codigo_prospecto,
            mesa: m.mesa,
          }))
        );
      } else {
        setIsModeLancamento(false);
        const corretores = await api.buscarCorretoresTransferencia(
          empreendimentoSelected.value
        );
        setOpcoesTransferencia(
          corretores.map(c => ({
            label: c.descricao,
            value: c.codigo,
          }))
        );
      }
    } catch (err) {
      toast.error('Erro ao carregar opções de transferência');
    }
  };

  const handleTransferencia = async () => {
    if (!transferenciaTarget) return;
    setLoadingTransferencia(true);
    try {
      const response = await api.transferenciaLote({
        codigo_ativo: detalhesAtivo.codigo,
        prospecto: parseInt(prospectoTransferencia),
        codigo_usuario: transferenciaTarget.value,
      });
      toast.success(response.message || 'Reserva transferida com sucesso');
      setMostrarTransferencia(false);
      fetchImoveis(empreendimentoSelected.value);
      fetchReservados();
      setDetalhesAtivo({});
      setIsAutoSelected(false);
    } catch (err) {
      toast.error(err.message || 'Erro ao transferir reserva');
    } finally {
      setLoadingTransferencia(false);
    }
  };

  const configuracaoPendencia = obterConfiguracaoPendencia(variantePendencia);
  const detalhesMensagemPendencia = separarMensagemPendencia(mensagemPendencia);
  const ehPendenciaErro = configuracaoPendencia.tom === 'erro';
  const corBasePendencia = ehPendenciaErro ? '#842029' : '#856404';
  const fundoBasePendencia = ehPendenciaErro ? '#f8d7da' : '#fff3cd';
  const bordaBasePendencia = ehPendenciaErro ? '#f5c2c7' : '#ffc107';
  const prospectoPendencia =
    codigoProspecto && codigoProspecto.trim() ? codigoProspecto.trim() : '-';
  const ativoPendencia =
    detalhesAtivo && detalhesAtivo.codigo ? detalhesAtivo.codigo : '-';
  const quadraLotePendencia =
    detalhesAtivo && (detalhesAtivo.quadra || detalhesAtivo.lote)
      ? `${detalhesAtivo.quadra || '-'} / ${detalhesAtivo.lote || '-'}`
      : '-';
  const empreendimentoPendencia = empreendimentoSelected
    ? empreendimentoSelected.label
    : '-';
  const dadosPendencia = [
    { rotulo: 'Prospecto/CPF informado', valor: prospectoPendencia },
    { rotulo: 'Empreendimento', valor: empreendimentoPendencia },
    { rotulo: 'Ativo', valor: ativoPendencia },
    { rotulo: 'Quadra / Lote', valor: quadraLotePendencia },
  ];

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul
        title="Mapa de Empreendimento"
        contemSelector={true}
        selectorPlaceholder="Selecione um empreendimento"
        options={optionsEmpreendimento}
        selectorValue={empreendimentoSelected}
        onSelectorChange={handleSelectorChange}
        selectorLoading={loading || loadingMapa || loadingReservados}
      />

      {!empreendimentoSelected && familia && (
        <div className="d-flex justify-content-center align-items-center py-5">
          <Spinner animation="border" variant="primary" />
          <span className="ml-2">Carregando empreendimento...</span>
        </div>
      )}

      {empreendimentoSelected && loadingMapa && !empreendimentoData && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            zIndex: 9999,
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {empreendimentoSelected && (
        <>
          <Row>
            <Col md={7} className="d-flex flex-column">
              {detalhesAtivo.codigo && (() => {
                const vt = getValoresTabela();
                return (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={4} lg={4} className="mb-1 pr-1">
                      <InfoCard
                        tamanho="pequeno"
                        valor={
                          vt.valorSinal
                            ? formatarMonetario(vt.valorSinal)
                            : '-'
                        }
                        titulo="Sinal (Parte A + Parte B)"
                        borderColor={borderColor}
                        width="100%"
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} className="mb-1 pr-1">
                      <InfoCard
                        tamanho="pequeno"
                        valor={
                          vt.valorVista
                            ? formatarMonetario(vt.valorVista)
                            : '-'
                        }
                        titulo="Valor à vista"
                        borderColor={borderColor}
                        width="100%"
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} className="mb-1 pr-1">
                      {detalhesAtivo.status != 1 && (
                        <div style={{ position: 'relative' }}>
                          <InfoCard
                            tamanho="pequeno"
                            valor={
                              vt.parcelas
                                ? formatarMonetario(vt.valorParcela)
                                : '-'
                            }
                            titulo={
                              vt.parcelas
                                ? 'Parcelas ' + vt.parcelas + ' x ' + (vt.descricaoTabela ? '(' + vt.descricaoTabela + ')' : '')
                                : 'Parcelas'
                            }
                            borderColor={borderColor}
                            width="100%"
                            botaoCopiar={true}
                            textoCopiado={
                              vt.parcelas
                                ? vt.parcelas + ' x ' + formatarMonetario(vt.valorParcela)
                                : ''
                            }
                            botaoRefresh={false}
                            botaoDropdown={tabelasDisponiveis.length > 1}
                            dropdownItens={tabelasDisponiveis.map(t => ({
                              value: t.codigo,
                              label: t.descricao,
                            }))}
                            dropdownValorSelecionado={
                              tabelasDisponiveis[indiceTabela]
                                ? tabelasDisponiveis[indiceTabela].codigo
                                : null
                            }
                            onSelecionarDropdown={handleSelecionarTabela}
                            loadingDropdown={loadingTabela}
                          />
                          {loadingTabela && (
                            <div
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'rgba(255,255,255,0.75)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 4,
                              }}
                            >
                              <Spinner animation="border" size="sm" variant="primary" />
                            </div>
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6} sm={6} md={4} lg={4} className="mb-1 pr-1">
                      <InfoCard
                        tamanho="pequeno"
                        valor={
                          detalhesAtivo.area ? `${detalhesAtivo.area} m²` : '-'
                        }
                        titulo="Área"
                        borderColor={borderColor}
                        width="100%"
                        botaoInfo={!!vt.memorial_descritivo}
                        infoTexto={vt.memorial_descritivo}
                      />
                    </Col>
                    <Col xs={6} sm={6} md={2} lg={2} className="mb-1 pr-1">
                      <InfoCard
                        tamanho="pequeno"
                        valor={detalhesAtivo.quadra || '-'}
                        titulo="Quadra"
                        borderColor={borderColor}
                        width="100%"
                      />
                    </Col>
                    <Col xs={12} sm={6} md={2} lg={2} className="mb-1 pr-1">
                      <InfoCard
                        tamanho="pequeno"
                        valor={detalhesAtivo.lote || '-'}
                        titulo="Lote"
                        borderColor={borderColor}
                        width="100%"
                      />
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={4} className="mb-1 pr-1">
                      <InfoCard
                        tamanho="pequeno"
                        valor={detalhesAtivo.cadastro_prefeitura || '-'}
                        titulo="Prefeitura"
                        borderColor={borderColor}
                        width="100%"
                        botaoLink={true}
                        link={detalhesAtivo.link_prefeitura}
                      />
                    </Col>
                  </Row>
                  {detalhesAtivo.status === StatusImovel.PreVenda && (
                    <Row>
                      <Col xs={12} className="mb-1 pr-1">
                        <InfoCard
                          tamanho="pequeno"
                          valor={
                            descricaoComprovante[detalhesAtivo.status_documentacao_proposta] || '-'
                          }
                          titulo="Status Comprovante"
                          borderColor={borderColor}
                          width="100%"
                        />
                      </Col>
                    </Row>
                  )}
                </>
                );
              })()}
              <div className="mt-auto">
                <Row
                  className="mt-2 px-3"
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px',
                    alignItems: 'center',
                  }}
                >
                  {detalhesAtivo.status !== StatusImovel.Vendido &&
                   detalhesAtivo.status !== StatusImovel.Bloqueado &&
                   detalhesAtivo.status !== StatusImovel.Disponivel && (
                    <Button
                      disabled={!detalhesAtivo.quadra || !detalhesAtivo.lote}
                      style={{
                        border: '1px solid #7bb32e',
                        borderRadius: 4,
                        color: '#7bb32e',
                        padding: '4px 14px',
                        background: 'transparent',
                        fontWeight: 600,
                        fontSize: '13px',
                      }}
                      href={
                        AuthStorage.temCaracteristica(495)
                          ? '#'
                          : empreendimentoSelected
                          ? `/fila-lote/${empreendimentoSelected.value}/${detalhesAtivo.codigo}/${detalhesAtivo.quadra}/${detalhesAtivo.lote}`
                          : '#'
                      }
                    >
                      <FaList />
                      {' Adicionar Na Fila'}
                      {loadingFila ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          className="ml-1"
                        />
                      ) : quantidadeFila !== null && quantidadeFila > 0 ? (
                        <Badge variant="light" className="ml-1">
                          {quantidadeFila}
                        </Badge>
                      ) : null}
                    </Button>
                  )}
                  {detalhesAtivo.codigo && (
                    <Button
                      style={{
                        border: '1px solid #333',
                        borderRadius: 4,
                        color: '#333',
                        padding: '4px 14px',
                        background: 'transparent',
                        fontWeight: 600,
                        fontSize: '13px',
                      }}
                      onClick={() => {
                        setCodigoAtivoSimulador(detalhesAtivo.codigo);
                        setMostrarSimulador(true);
                      }}
                    >
                      $ Simulador Fin.
                    </Button>
                  )}

                  {empreendimentoSelected && (
                    <>
                      <Button
                        style={{
                          border: '1px solid #0747a6',
                          borderRadius: 4,
                          color: '#0747a6',
                          padding: '4px 14px',
                          background: 'transparent',
                          fontWeight: 600,
                          fontSize: '13px',
                        }}
                        onClick={() => setMostrarLotesDisponiveis(true)}
                      >
                        <FaList />
                        {` Lotes Disp.`}
                      </Button>
                      <Button
                        style={{
                          border: '1px solid #468400',
                          borderRadius: 4,
                          color: '#468400',
                          padding: '4px 14px',
                          background: 'transparent',
                          fontWeight: 600,
                          fontSize: '13px',
                        }}
                        onClick={() => setMostrarContaBancaria(true)}
                      >
                        <FaPiggyBank />
                        {` Conta Bancaria`}
                      </Button>
                    </>
                  )}
                  {empreendimentoSelected &&
                    !AuthStorage.isADM() &&
                    reservados.length > 0 &&
                    (prospectoUnicoReservados ||
                      (reservaSelecionada &&
                        reservaSelecionada.codigo_prospecto)) && (
                      <Button
                        style={{
                          border: '1px solid #28a745',
                          borderRadius: 4,
                          color: '#fff',
                          padding: '4px 14px',
                          background: '#28a745',
                          fontWeight: 600,
                          fontSize: '13px',
                        }}
                        onClick={() => {
                          const codigoProspectoVenda =
                            prospectoUnicoReservados ||
                            reservaSelecionada.codigo_prospecto;
                          history.push(
                            `/vendas/prospecto/${codigoProspectoVenda}/empreendimento/${empreendimentoSelected.value}`
                          );
                        }}
                      >
                        <FaShoppingCart />
                        {` Iniciar Venda`}
                      </Button>
                    )}
                  {podeTransferir && (
                    <Button
                      style={{
                        border: '1px solid #e67e22',
                        borderRadius: 4,
                        color: '#fff',
                        padding: '4px 14px',
                        background: '#e67e22',
                        fontWeight: 600,
                        fontSize: '13px',
                      }}
                      onClick={abrirTransferencia}
                    >
                      <FaExchangeAlt />
                      {` Transferir`}
                    </Button>
                  )}
                  {detalhesAtivo.status === StatusImovel.Reservado &&
                    detalhesAtivo.nome_corretor && (
                      <div
                        style={{
                          background: '#fe951d',
                          color: '#fff',
                          borderRadius: 4,
                          padding: '4px 14px',
                          fontSize: '13px',
                          fontWeight: 600,
                          display: 'inline-flex',
                          alignItems: 'center',
                        }}
                      >
                        Reservado para: {detalhesAtivo.nome_corretor}
                      </div>
                    )}
                </Row>
                <Row
                  className="mt-2 px-3"
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px',
                    alignItems: 'center',
                  }}
                >
                  {detalhesAtivo.status === 0 && !temCaracteristica453 && (
                    <OverlayTrigger
                      overlay={
                        <Tooltip>
                          Reserve o lote {detalhesAtivo.quadra}/
                          {detalhesAtivo.lote} para o prospecto:{' '}
                          {codigoProspecto}
                        </Tooltip>
                      }
                    >
                      <div
                        style={{
                          display: 'inline-flex',
                          alignItems: 'stretch',
                          height: 30,
                        }}
                      >
                        <FormControl
                          type="text"
                          placeholder="Prospecto/CPF"
                          value={codigoProspecto}
                          onChange={e => setCodigoProspecto(e.target.value)}
                          style={{
                            width: 120,
                            height: 30,
                            borderRadius: '4px 0 0 4px',
                            borderRight: 'none',
                            boxSizing: 'border-box',
                            fontSize: '13px',
                          }}
                        />
                        <Button
                          disabled={!codigoProspecto.trim() || loading}
                          style={{
                            border: '1px solid #ffba1a',
                            borderRadius: '0 4px 4px 0',
                            color: '#fff',
                            background: '#ffba1a',
                            padding: '0 10px',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          onClick={() => handleReservar()}
                        >
                          {` Reservar`}
                        </Button>
                      </div>
                    </OverlayTrigger>
                  )}
                  {detalhesAtivo.status === 0 && temCaracteristica453 && (
                    <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'stretch',
                        height: 30,
                      }}
                    >
                      <FormControl
                        type="text"
                        placeholder="Informe o motivo da reserva"
                        value={justificativaAdmin}
                        onChange={e => setJustificativaAdmin(e.target.value)}
                        style={{
                          width: 250,
                          height: 30,
                          borderRadius: '4px 0 0 4px',
                          borderRight: 'none',
                          boxSizing: 'border-box',
                          fontSize: '13px',
                        }}
                      />
                      <Button
                        disabled={!justificativaAdmin.trim() || loading}
                        style={{
                          border: '1px solid #ffba1a',
                          borderRadius: '0 4px 4px 0',
                          color: '#fff',
                          background: '#ffba1a',
                          padding: '0 10px',
                          display: 'flex',
                          alignItems: 'center',
                          whiteSpace: 'nowrap',
                        }}
                        onClick={() => handleReservar()}
                      >
                        {loading ? ' Reservando...' : ' Reserva Administrativa'}
                      </Button>
                    </div>
                  )}
                  {implantacaoArquivo && (
                    <Button
                      style={{
                        border: '1px solid #17a2b8',
                        borderRadius: 4,
                        color: '#17a2b8',
                        padding: '4px 14px',
                        background: 'transparent',
                        fontWeight: 600,
                        fontSize: '13px',
                      }}
                      onClick={handleAbrirImplantacao}
                    >
                      Implantação
                    </Button>
                  )}
                </Row>
              </div>
            </Col>
            <Col xs={12} md={5} className="mt-3 mt-md-0">
              <Tabela
                colunas={colunasReservados}
                dados={reservados}
                action={true}
                acoes={[
                  {
                    icon: <FaTrashAlt />,
                    onClick: rowData => abrirModalCancelamento(rowData),
                  },
                ]}
                fontSize="12px"
                striped={true}
                hover={true}
                card={true}
                headerTitle="Reservados"
                cardStyle={{ height: '203px' }}
                cliqueLinha={item =>
                  setReservaSelecionada(
                    reservaSelecionada &&
                      reservaSelecionada.codigo_ativo === item.codigo_ativo
                      ? null
                      : item
                  )
                }
                linhaSelecionada={item =>
                  reservaSelecionada &&
                  reservaSelecionada.codigo_ativo === item.codigo_ativo
                }
              />
            </Col>
          </Row>
          <div
            style={{
              width: '100%',
              height: '2px',
              background: 'linear-gradient(90deg, #0747a6, #7daaffff)',
              margin: '8px 0',
            }}
          />
          <Row
            className="mt-3"
            style={{
              alignItems: 'center',
              boxShadow: '0 4px 4px -2px rgba(0,0,0,0.15)',
              padding: '8px 0',
              marginLeft: 0,
              marginRight: 0,
            }}
          >
            <Col xs={12} md={2} className="mb-1">
              <Select
                isMulti
                options={optionsQuadras}
                value={filtroQuadras}
                onChange={selected => setFiltroQuadras(selected || [])}
                placeholder="Quadra..."
                noOptionsMessage={() => 'Nenhuma quadra'}
                isClearable
              />
            </Col>

            <Col xs={12} md={5} className="mb-1">
              <ContadorLotes
                lotes={empreendimentoData}
                statusSelecionados={filtroStatus}
                onStatusClick={function(status) {
                  setFiltroStatus(function(prev) {
                    return prev.includes(status)
                      ? prev.filter(function(s) {
                          return s !== status;
                        })
                      : prev.concat(status);
                  });
                }}
              />
            </Col>

            <Col xs={12} md={5}>
              <div
                className="d-flex justify-content-center justify-content-md-end"
                style={{
                  alignItems: 'center',
                  flexWrap: 'nowrap',
                }}
              >
                <label style={checkboxStyle}>
                  <input
                    type="checkbox"
                    style={checkboxInputStyle}
                    checked={filtroTipologias.includes(1)}
                    onChange={() => handleTipologiaChange(1)}
                  />
                  <span style={checkboxLabelStyle}>Residencial</span>
                </label>
                <label style={checkboxStyle}>
                  <input
                    type="checkbox"
                    style={checkboxInputStyle}
                    checked={filtroTipologias.includes(4)}
                    onChange={() => handleTipologiaChange(4)}
                  />
                  <span style={checkboxLabelStyle}>Misto</span>
                </label>
                <label style={checkboxStyle}>
                  <input
                    type="checkbox"
                    style={checkboxInputStyle}
                    checked={filtroTipologias.includes(3)}
                    onChange={() => handleTipologiaChange(3)}
                  />
                  <span style={checkboxLabelStyle}>Vertical</span>
                </label>
                <label style={checkboxStyle}>
                  <input
                    type="checkbox"
                    style={checkboxInputStyle}
                    checked={filtroTipologias.includes(2)}
                    onChange={() => handleTipologiaChange(2)}
                  />
                  <span style={checkboxLabelStyle}>Comercial</span>
                </label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              {loadingMapa && empreendimentoData && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '40px 0',
                  }}
                >
                  <Spinner animation="border" variant="primary" />
                  <span className="mt-2 text-muted">Carregando mapa...</span>
                </div>
              )}
              {lotesFiltrados && !loadingMapa && (
                <MapaQuadriculado
                  lotes={lotesFiltrados}
                  loading={loadingMapa}
                  onLoteClick={lote => fetchImovelData(lote.codigo)}
                />
              )}
            </Col>
          </Row>
          <SimuladorFinanceiro
            show={mostrarSimulador}
            onHide={() => setMostrarSimulador(false)}
            codigoAtivo={codigoAtivoSimulador}
          />
          <LotesDisponiveisModal
            show={mostrarLotesDisponiveis}
            onHide={() => setMostrarLotesDisponiveis(false)}
            codigoFamilia={
              empreendimentoSelected ? empreendimentoSelected.value : null
            }
          />
          <ContaBancariaModal
            show={mostrarContaBancaria}
            onHide={() => setMostrarContaBancaria(false)}
            codigoFamilia={
              empreendimentoSelected ? empreendimentoSelected.value : null
            }
          />
          <Modal
            show={mostrarAvisoInadimplente}
            onHide={() => setMostrarAvisoInadimplente(false)}
            centered
          >
            <Modal.Header
              closeButton
              style={{
                background: '#fff3cd',
                borderBottom: '1px solid #ffc107',
              }}
            >
              <Modal.Title
                style={{ color: '#856404', fontSize: '16px', fontWeight: 600 }}
              >
                Aviso
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ whiteSpace: 'pre-line' }}>
              {avisoInadimplente}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="warning"
                onClick={() => setMostrarAvisoInadimplente(false)}
              >
                Entendi
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={mostrarModalPendencia}
            onHide={() => setMostrarModalPendencia(false)}
            centered
            size="lg"
          >
            <Modal.Header
              closeButton
              style={{
                background: fundoBasePendencia,
                borderBottom: `1px solid ${bordaBasePendencia}`,
              }}
            >
              <Modal.Title
                style={{
                  color: corBasePendencia,
                  fontSize: '16px',
                  fontWeight: 600,
                }}
              >
                {configuracaoPendencia.titulo}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: 0 }}>
              <div style={{ padding: '18px 20px 16px' }}>
                <div
                  style={{
                    background: fundoBasePendencia,
                    border: `1px solid ${bordaBasePendencia}`,
                    borderRadius: 4,
                    color: corBasePendencia,
                    padding: '12px 14px',
                    marginBottom: 14,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: 8,
                      marginBottom: 6,
                    }}
                  >
                    <strong style={{ fontSize: 15 }}>Reserva bloqueada</strong>
                    {configuracaoPendencia.etiqueta && (
                      <Badge variant={ehPendenciaErro ? 'danger' : 'warning'}>
                        {configuracaoPendencia.etiqueta}
                      </Badge>
                    )}
                  </div>
                  <div style={{ fontSize: 13 }}>
                    {configuracaoPendencia.descricao}
                  </div>
                </div>

                <div
                  style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: 4,
                    marginBottom: 14,
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      background: '#f8f9fa',
                      borderBottom: '1px solid #e5e7eb',
                      fontSize: 13,
                      fontWeight: 600,
                      padding: '8px 12px',
                    }}
                  >
                    Dados da tentativa
                  </div>
                  <Row style={{ margin: 0 }}>
                    {dadosPendencia.map(item => (
                      <Col
                        key={item.rotulo}
                        xs={12}
                        md={6}
                        style={{
                          borderBottom: '1px solid #f1f3f5',
                          padding: '10px 12px',
                        }}
                      >
                        <div
                          style={{
                            color: '#6c757d',
                            fontSize: 11,
                            fontWeight: 600,
                            textTransform: 'uppercase',
                          }}
                        >
                          {item.rotulo}
                        </div>
                        <div style={{ color: '#212529', fontSize: 13 }}>
                          {item.valor}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>

                {detalhesMensagemPendencia.resumo.length > 0 && (
                  <div style={{ marginBottom: 14 }}>
                    <div
                      style={{
                        color: '#495057',
                        fontSize: 12,
                        fontWeight: 600,
                        marginBottom: 6,
                      }}
                    >
                      Motivo retornado pela validação
                    </div>
                    {detalhesMensagemPendencia.resumo.map(item => (
                      <div
                        key={item}
                        style={{
                          background: '#f8f9fa',
                          border: '1px solid #e9ecef',
                          borderRadius: 4,
                          color: '#343a40',
                          fontSize: 13,
                          padding: '9px 10px',
                        }}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                )}

                <div
                  style={{
                    borderLeft: `4px solid ${bordaBasePendencia}`,
                    color: '#343a40',
                    fontSize: 13,
                    padding: '4px 0 4px 10px',
                  }}
                >
                  {detalhesMensagemPendencia.detalhes.map(item => (
                    <div key={item} style={{ marginBottom: 4 }}>
                      {item}
                    </div>
                  ))}
                  <div>{configuracaoPendencia.acao}</div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setMostrarModalPendencia(false)}
              >
                {configuracaoPendencia.botaoCancelar}
              </Button>
              {variantePendencia === 'sem-solicitacao' && (
                <Button
                  variant="primary"
                  onClick={handleSolicitarPendencia}
                  disabled={solicitandoPendencia}
                >
                  {solicitandoPendencia
                    ? 'Enviando...'
                    : 'Solicitar Autorização'}
                </Button>
              )}
            </Modal.Footer>
          </Modal>
          <Modal
            show={mostrarTransferencia}
            onHide={() => setMostrarTransferencia(false)}
            centered
          >
            <Modal.Header closeButton style={{ background: '#f8f9fa' }}>
              <Modal.Title style={{ fontSize: '16px', fontWeight: 600 }}>
                Transferir Reserva - Quadra {detalhesAtivo.quadra} / Lote{' '}
                {detalhesAtivo.lote}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ marginBottom: 12 }}>
                <small>
                  Corretor atual:{' '}
                  <strong>{detalhesAtivo.nome_corretor || '-'}</strong>
                </small>
                <br />
                <small>
                  Prospecto atual:{' '}
                  <strong>
                    {(detalhesAtivo.ticket &&
                      detalhesAtivo.ticket.codigo_prospecto) ||
                      '-'}
                    {detalhesAtivo.nome_prospecto
                      ? ` - ${detalhesAtivo.nome_prospecto}`
                      : ''}
                  </strong>
                </small>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontWeight: 600, fontSize: 13 }}>
                  {isModeLancamento
                    ? 'Mesa para transferência'
                    : 'Corretor destino'}
                </label>
                <Select
                  options={opcoesTransferencia}
                  placeholder={
                    isModeLancamento
                      ? 'Selecione uma mesa...'
                      : 'Selecione um corretor...'
                  }
                  onChange={option => {
                    setTransferenciaTarget(option);
                    if (isModeLancamento && option && option.prospecto) {
                      setProspectoTransferencia(option.prospecto.toString());
                    }
                  }}
                  isClearable
                />
              </div>
              <div>
                <label style={{ fontWeight: 600, fontSize: 13 }}>
                  Prospecto
                </label>
                <FormControl
                  type="text"
                  value={prospectoTransferencia}
                  onChange={e => setProspectoTransferencia(e.target.value)}
                  disabled={isModeLancamento}
                  placeholder="Código do prospecto"
                  style={{ fontSize: 13 }}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setMostrarTransferencia(false)}
              >
                Cancelar
              </Button>
              <Button
                style={{ background: '#e67e22', border: 'none' }}
                disabled={
                  !transferenciaTarget ||
                  !prospectoTransferencia ||
                  loadingTransferencia
                }
                onClick={handleTransferencia}
              >
                {loadingTransferencia ? 'Transferindo...' : 'Transferir'}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
      {mostrarModalCancelamento && ativoCancelamento && (
        <Modal
          backdrop="static"
          show={mostrarModalCancelamento}
          onHide={fecharModalCancelamento}
          size="lg"
        >
          <Modal.Header
            closeButton
            style={{ backgroundColor: '#0747a6', color: '#fff' }}
          >
            <Modal.Title style={{ color: '#fff' }}>Excluir Reserva</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="bg-light p-3 rounded mb-3">
              <strong>Quadra:</strong> {ativoCancelamento.mapa1} |{' '}
              <strong>Lote:</strong> {ativoCancelamento.mapa2}
              {ativoCancelamento.prospecto && (
                <span>
                  {' '}
                  | <strong>Prospecto:</strong> {ativoCancelamento.prospecto}
                </span>
              )}
            </div>
            <div className="mb-3">
              <label className="font-weight-bold mb-2">Motivos *</label>
              <Select
                isMulti
                options={optionsMotivos}
                value={motivosSelecionados}
                onChange={selected => setMotivosSelecionados(selected || [])}
                placeholder="Selecione os motivos..."
                noOptionsMessage={() => 'Nenhum motivo encontrado'}
                isClearable
                closeMenuOnSelect={false}
              />
            </div>
            {motivosSelecionadosComSubMotivos.map(motivo => (
              <div key={motivo.codigo} className="mb-3">
                <label
                  className="font-weight-bold mb-1"
                  style={{ fontSize: '13px' }}
                >
                  {motivo.descricao}
                </label>
                {motivo.sub_motivos.map(subMotivo => {
                  var selecionado = motivosSelecionados.find(
                    s => s.value === motivo.codigo
                  );
                  return (
                    <div
                      key={subMotivo.codigo}
                      className="d-flex align-items-center mb-1 ml-2"
                    >
                      <label
                        className="mr-2 mb-0"
                        style={{ minWidth: '120px', fontSize: '12px' }}
                      >
                        {subMotivo.descricao}:
                      </label>
                      <FormControl
                        size="sm"
                        placeholder={
                          'Descreva ' + subMotivo.descricao.toLowerCase()
                        }
                        value={
                          selecionado &&
                          selecionado.codigo_submotivo === subMotivo.codigo
                            ? selecionado.dissertativa || ''
                            : ''
                        }
                        onChange={e =>
                          atualizarSubMotivo(
                            motivo.codigo,
                            subMotivo.codigo,
                            e.target.value
                          )
                        }
                        maxLength={200}
                      />
                    </div>
                  );
                })}
              </div>
            ))}
            <div className="mb-3">
              <label className="font-weight-bold mb-2">Observações</label>
              <FormControl
                as="textarea"
                rows={3}
                placeholder="Informe observações sobre o cancelamento..."
                value={observacoesCancelamento}
                onChange={e => setObservacoesCancelamento(e.target.value)}
                maxLength={500}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button variant="secondary" onClick={fecharModalCancelamento}>
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={confirmarCancelamento}
              disabled={cancelando || !temMotivoSelecionado}
            >
              {cancelando ? 'Excluindo...' : 'Excluir Reserva'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};

export default MapaEmprendimento;
